<template>
  <div>
    <div class="container">
      <div class="row">
        <div v-if="error" class="alert alert-danger">{{ error }}</div>
        <div
          v-if="status === 'submitted'"
          class="alert alert-success"
        >Your message submitted successfully.</div>
      </div>
      <div class="row">
        <div class="row mt-1" v-if="status !== 'submitted'">
          <div class="col-sm-12" v-if="user.loggedIn === false">
            <fieldset role="group" class="b-form-group form-group">
              <div role="group" class>
                <input
                  id="name"
                  type="text"
                  placeholder="Enter your Full Name"
                  class="form-control"
                  v-model.trim="form.name"
                />
              </div>
            </fieldset>
          </div>
          <div :class="user.loggedIn ? 'col-sm-12' : 'col-sm-6'" v-if="user.loggedIn === false">
            <fieldset role="group" class="b-form-group form-group">
              <div role="group" class>
                <input
                  id="email"
                  type="text"
                  placeholder="Enter your Email"
                  class="form-control"
                  v-model.trim="form.email"
                />
              </div>
            </fieldset>
          </div>
          <div :class="user.loggedIn ? 'col-sm-12' : 'col-sm-6'">
            <fieldset role="group" class="b-form-group form-group">
              <div role="group" class>
                <input
                  id="phone"
                  type="text"
                  placeholder="Enter your Phone number"
                  class="form-control"
                  v-model.trim="form.phone"
                />
              </div>
            </fieldset>
          </div>
          <div class="col-sm-12">
            <fieldset role="group" class="b-form-group form-group">
              <div role="group" class>
                <input
                  id="subject"
                  type="text"
                  placeholder="Subject"
                  class="form-control"
                  v-model.trim="form.subject"
                />
              </div>
            </fieldset>
          </div>
          <div class="col-sm-12">
            <fieldset role="group" class="b-form-group form-group">
              <div role="group" class>
                <textarea
                  id="message"
                  type="text"
                  rows="5"
                  placeholder="Enter your Message"
                  class="form-control"
                  v-model.trim="form.message"
                />
              <span>{{form.message.length}} / {{allowed_length_per_message_max}} Characters. Min {{allowed_length_per_message_min}} Characters required.</span>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-12 text-center pt-2">
            <button class="btn btn-secondary animated flipInX" style="cursor:pointer;" v-if="(form.message.length < allowed_length_per_message_min) || (form.message > allowed_length_per_message_max)">Send</button>
            <button class="btn btn-primary animated flipInX" v-else @click="submitMessage">Send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { db } from "@/firebase_db";
import { mapGetters } from "vuex";
import { validPhoneNo, emailIsValid } from "@/app/utils";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        message: "",
        msg_read: false,
        notes: []
      },
      allowed_length_per_message_min: 24,
      allowed_length_per_message_max: 240,
      error: null,
      status: "new"
    };
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  },
  methods: {
    validate() {
      if (this.user.loggedIn && this.user.data) {
        this.form.name = this.user.data.displayName || this.user.data.email;
        this.form.email = this.user.data.email;
      }

      if (!this.form.name) {
        (this.error = "Enter your name and contact details"),
          (this.status = "error");
      } else if (!validPhoneNo(this.form.phone)) {
        (this.error = "Enter valid phone number"), (this.status = "error");
      } else if(!emailIsValid(this.form.email)){
        (this.error = "Enter valid email"), (this.status = "error");
      } else if (!this.form.subject) {
        (this.error = "Enter subject"), (this.status = "error");
      } else if (!this.form.message) {
        (this.error = "Enter Your message"), (this.status = "error");
      } else {
        this.error = null;
      }
    },
    submitMessage() {
      this.validate();
      if (this.error) {
        return;
      } else {
        this.status = "validated";
        this.error = null;
        this.form.timestamp = new Date();
        db.collection("messages")
          .add(this.form)
          .then(docRef => {
            this.status = "submitted";
            this.error = null;
            this.$gtag.event('message-submitted-to-moderator');
            setTimeout(() => {
              this.form.message = "";
              this.status = "new";
              this.error = null;
            }, 5 * 1000);
          })
          .catch(error => {
            this.$gtag.event('message-submitted-to-moderator-failed');
            this.error = error;
            this.status = "error";
          });
      }
    }
  }
};
</script>
